/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
export type IEdiOutboundNodeFragment = { __typename?: 'OutboundConnectionConfig' } & Pick<
  Types.IOutboundConnectionConfig,
  | 'id'
  | 'partnerApplicationId'
  | 'partnerApplicationType'
  | 'connectionType'
  | 'disabled'
  | 'environment'
  | 'host'
  | 'port'
  | 'username'
  | 'secretKey'
  | 'pathPrefix'
  | 'createdAt'
  | 'componentSeparator'
  | 'destinationOverride'
  | 'elementSeparator'
  | 'groupVersionStr'
  | 'gsReceiverId'
  | 'gsSenderId'
  | 'interchangeVersionStr'
  | 'isaReceiverId'
  | 'isaReceiverIdQualifier'
  | 'isaSenderId'
  | 'isaSenderIdQualifier'
  | 'repetitionSeparator'
  | 'segmentSeparator'
  | 'testIndicator'
  | 'tmsName'
  | 'expect997s'
> & {
    partnerApplication?: Types.Maybe<
      | ({ __typename: 'CarrierApplication' } & Pick<Types.ICarrierApplication, 'id'> & {
            carrierName: Types.ICarrierApplication['name']
          })
      | ({ __typename: 'ShipperApplication' } & Pick<Types.IShipperApplication, 'id'> & {
            shipperName: Types.IShipperApplication['name']
          })
    >
    as2ConnectionConfig?: Types.Maybe<
      { __typename?: 'As2ConnectionConfig' } & Pick<
        Types.IAs2ConnectionConfig,
        | 'id'
        | 'createdAt'
        | 'identifier'
        | 'outboundUrl'
        | 'serverInfoCredentialsIdentifier'
        | 'transfixIdentifier'
        | 'updatedAt'
      > & {
          as2Certificates: Array<
            { __typename?: 'As2Certificate' } & Pick<
              Types.IAs2Certificate,
              | 'id'
              | 'body'
              | 'x509ReadError'
              | 'notAfter'
              | 'notBefore'
              | 'createdAt'
              | 'isActive'
              | 'updatedAt'
            >
          >
        }
    >
  }

export const EdiOutboundNodeFragmentDoc = gql`
  fragment EdiOutboundNode on OutboundConnectionConfig {
    id
    partnerApplication {
      __typename
      ... on ShipperApplication {
        id
        shipperName: name
      }
      ... on CarrierApplication {
        id
        carrierName: name
      }
    }
    partnerApplicationId
    partnerApplicationType
    connectionType
    disabled
    environment
    host
    port
    username
    secretKey
    pathPrefix
    createdAt
    componentSeparator
    destinationOverride
    elementSeparator
    groupVersionStr
    gsReceiverId
    gsSenderId
    interchangeVersionStr
    isaReceiverId
    isaReceiverIdQualifier
    isaSenderId
    isaSenderIdQualifier
    repetitionSeparator
    segmentSeparator
    testIndicator
    tmsName
    expect997s
    as2ConnectionConfig {
      id
      as2Certificates {
        id
        body
        x509ReadError
        notAfter
        notBefore
        createdAt
        isActive
        updatedAt
      }
      createdAt
      identifier
      outboundUrl
      serverInfoCredentialsIdentifier
      transfixIdentifier
      updatedAt
    }
  }
`
